import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Окружение", -1)

import {useDialog} from '@/uses/Dialogs/useDialog'
import {EnvCodeEnum, useEnvStore} from '@/stores/useEnvStore'
import {storeToRefs} from 'pinia'
import {ref} from 'vue'
import CopyToClipboard from '@/components/CopyToClipboard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnvEditComponent',
  setup(__props) {

const {
  isEditable,
  getEnvValue,
  setValue,
  setToDefault,
} = useEnvStore()

const {
  editable,
} = storeToRefs(useEnvStore())

const {
  dialog,
  show,
} = useDialog()

const changes = ref<{code: EnvCodeEnum, value: string}[]>([])

const getChange = (code: EnvCodeEnum) => {
  return changes.value
    .find(change => change.code === code)
}

const getValue = (code: EnvCodeEnum) => {
  const change = getChange(code)

  return change
    ? change.value
    : getEnvValue(code)
}

const onChange = (code: EnvCodeEnum, value: string) => {
  const index = changes.value
    .findIndex(change => change.code === code)

  if (getEnvValue(code) === value && index === -1) {
    return
  }

  if (getEnvValue(code) === value && index !== -1) {
    changes.value.splice(index, 1)
    return
  }

  if (index === -1) {
    changes.value.push({code, value})
    return
  }

  changes.value[index] = {code, value}
}

const save = () => {
  changes.value
    .forEach(change => {
      setValue(change.code, change.value)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(editable) && !_unref(dialog))
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: "fixed-top-left z-top q-ma-xs",
          size: "xs",
          icon: "app-cog",
          color: "primary",
          square: "",
          flat: "",
          dense: "",
          onClick: _unref(show)
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"400px","max-width":"800px","width":"60vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EnvCodeEnum), (code) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: code,
                    class: "row"
                  }, [
                    _createVNode(_component_q_input, {
                      "model-value": getValue(code),
                      class: "field-with-top-label col q-mb-sm",
                      label: code,
                      disable: !_unref(isEditable)(code),
                      outlined: "",
                      "hide-bottom-space": "",
                      dense: "",
                      "onUpdate:modelValue": ($event: any) => (onChange(code, $event))
                    }, _createSlots({ _: 2 }, [
                      (getChange(code))
                        ? {
                            name: "after",
                            fn: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "app-information-circle-bold"
                              })
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["model-value", "label", "disable", "onUpdate:modelValue"]),
                    (getValue(code))
                      ? (_openBlock(), _createBlock(CopyToClipboard, {
                          key: 0,
                          text: getValue(code)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              class: "q-ml-sm",
                              style: {"margin-top":"42px"},
                              icon: "app-document-duplicate",
                              size: "xs",
                              color: "blue-grey-4",
                              round: "",
                              flat: ""
                            })
                          ]),
                          _: 2
                        }, 1032, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              class: "row justify-end q-py-md",
              style: {"background":"#D5EAFA"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  padding: "sm md",
                  size: "16px",
                  color: "black",
                  label: "По умолчанию",
                  unelevated: "",
                  "no-caps": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(setToDefault)(); changes.value = []})
                }),
                _createVNode(_component_q_btn, {
                  padding: "sm md",
                  size: "16px",
                  color: "blue-7",
                  label: "Сохранить",
                  disable: changes.value.length === 0,
                  unelevated: "",
                  "no-caps": "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {save(); changes.value = []})
                }, null, 8, ["disable"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})